module.exports = __webpack_public_path__ + "img/25thanniversary.a1c729b1.svg";